import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/src/app/global.scss");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/src/app/layout.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/src/app/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/src/app/svg-sprite.tsx");
